const PropTypes = require('prop-types');
const React = require('react');
const ReactImageCrop = require('react-image-crop/dist/ReactCrop.js');
const classNames = require('classnames');

class Editor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCropping: false,
      photo: this.props.photo,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.photo !== this.props.photo) {
      this.state = {
        isCropping: false,
        photo: nextProps.photo,
      };
    }
  }

  handleCropChange(crop) {
    const newCrop = crop;
    newCrop.aspect = 1; // force a square aspect ratio

    this.setState({ crop: newCrop });
  }

  handleImageDoneLoading() {
    this.setState({ isLoadingPhoto: false });
  }

  startCrop() {
    let initialCrop = this.state.photo.crop;
    if (!initialCrop.width) {
      initialCrop = { width: 100, aspect: 1 };
    }

    this.setState({
      isCropping: true,
      crop: initialCrop,
      initialCrop,
    });
  }

  cancelCrop() {
    this.setState({
      isCropping: false,
      crop: this.state.initialCrop,
    });
  }

  saveCrop(callback) {
    const newPhoto = this.state.photo.copy();
    newPhoto.crop = this.state.crop;

    this.setState({ isCropping: false, photo: newPhoto }, callback);
  }

  rotate() {
    const newPhoto = this.state.photo.copy();
    newPhoto.rotate();

    this.setState({ photo: newPhoto, isLoadingPhoto: true });
  }

  savePhoto() {
    if (this.state.isCropping) {
      this.saveCrop(() => {
        this.props.onUpdatePhoto(this.state.photo);
      });
    } else {
      this.props.onUpdatePhoto(this.state.photo);
    }
  }

  closeEditor() {
    this.props.onCloseEditor();
  }

  renderInitialState() {
    const imgBackgroundClassNames = classNames(
      'img-editor__img-background',
      { 'img-editor__img-background--loading': this.state.isLoadingPhoto }
    );

    return (
      <div>
        <div className={imgBackgroundClassNames}>
          <img
            src={this.state.photo.fullUrl}
            className="img-editor__preview-image"
            role="presentation"
            onLoad={() => this.handleImageDoneLoading()}
          />
        </div>
        <div className="img-editor__edit-actions">
          <a
            className="img-editor__edit-action img-editor__edit-action--rotate"
            onClick={() => this.rotate()}
          />
          <a
            className="img-editor__edit-action img-editor__edit-action--crop"
            onClick={() => this.startCrop()}
          >
            {I18n.t('js.listingForm.photos.editor.cropToSquare')}
          </a>
        </div>
      </div>
    );
  }

  renderCroppingState() {
    return (
      <div>
        <div className="img-editor__img-background">
          <ReactImageCrop
            src={this.state.photo.fullUrlWithoutCrop}
            crop={this.state.crop}
            onChange={(crop) => this.handleCropChange(crop)}
            onImageLoaded={(crop) => this.handleCropChange(crop)}
            keepSelection
          />
        </div>
        <div className="img-editor__edit-actions">
          <a
            className="img-editor__edit-action img-editor__edit-action--cancel"
            onClick={() => this.cancelCrop()}
          >
            {I18n.t('js.listingForm.photos.editor.cancel')}
          </a>
          <a
            className="img-editor__edit-action img-editor__edit-action--done"
            onClick={() => this.saveCrop()}
          >
            {I18n.t('js.listingForm.photos.editor.done')}
          </a>
        </div>
      </div>
    );
  }

  renderControls() {
    if (this.state.isCropping) {
      return this.renderCroppingState();
    }
    return this.renderInitialState();
  }

  render() {
    return (
      <div className="img-editor">
        <div className="img-editor__editor-frame">
          {this.renderControls()}
        </div>
        <div className="img-editor__actions">
          <a
            className="img-editor__action img-editor__action--close"
            onClick={() => this.closeEditor()}
          >
            {I18n.t('js.listingForm.photos.editor.cancel')}
          </a>
          <a
            className="img-editor__action img-editor__action--save"
            onClick={() => this.savePhoto()}
          >
            {I18n.t('js.listingForm.photos.editor.save')}
          </a>
        </div>
      </div>
    );
  }
}

Editor.propTypes = {
  photo: PropTypes.object.isRequired,
  onUpdatePhoto: PropTypes.func.isRequired,
  onCloseEditor: PropTypes.func.isRequired,
};

module.exports = Editor;



// WEBPACK FOOTER //
// ./javascripts/components/photos/editor.jsx